module.exports = __webpack_public_path__ + "img/projects-passport.89229e5d.svg";